<template>
  <section class="conocenos" id="conocenos">
    <!-- FONDO TECNOLÓGICO Y CIRCUITO DINÁMICO (Inspirado en circuito con nodos concéntricos) -->
    <div class="conocenos__bg" aria-hidden="true">
      <div class="bg-gradient-base"></div>
      <div class="bg-glow glow-1"></div>
      <div class="bg-glow glow-2"></div>
      <div class="tech-grid-overlay"></div>

      <!-- SVG de Circuito Electrónico con Trazas, Nodos y Pulsos en Movimiento -->
      <svg class="network-svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
        <defs>
          <filter id="circuit-neon-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <!-- Red de Trazas Principales (Líneas sólidas y punteadas) -->
        <g class="circuit-traces">
          <!-- Ruta 1: Superior Izquierda a Centro -->
          <path d="M 80,120 L 220,120 L 220,280 L 480,280 L 520,320 L 680,320" class="circuit-line solid" />
          <path d="M 220,120 L 220,280" class="circuit-line dashed" />

          <!-- Ruta 2: Centro a Inferior Derecha -->
          <path d="M 520,320 L 520,480 L 760,480 L 820,540 L 1120,540" class="circuit-line solid" />
          <path d="M 760,480 L 760,660 L 980,660" class="circuit-line dashed" />

          <!-- Ruta 3: Inferior Izquierda a Centro -->
          <path d="M 120,620 L 320,620 L 380,560 L 380,420 L 480,420" class="circuit-line solid" />
          <path d="M 320,620 L 320,460" class="circuit-line dashed" />

          <!-- Ruta 4: Superior Derecha a Centro -->
          <path d="M 1100,160 L 900,160 L 840,220 L 680,220" class="circuit-line solid" />
          <path d="M 900,160 L 900,340 L 760,340" class="circuit-line dashed" />

          <!-- Ramificaciones secundarias -->
          <line x1="80" y1="120" x2="40" y2="120" class="circuit-line branch" />
          <line x1="480" y1="280" x2="480" y2="240" class="circuit-line branch" />
          <line x1="680" y1="320" x2="740" y2="320" class="circuit-line branch" />
          <line x1="380" y1="420" x2="380" y2="380" class="circuit-line branch" />
          <line x1="1120" y1="540" x2="1160" y2="540" class="circuit-line branch" />
        </g>

        <!-- Nodos Concéntricos en el Circuito (Como en la imagen de referencia) -->
        <g class="circuit-nodes">
          <!-- Nodo 1 -->
          <g class="circuit-node-glyph" transform="translate(80, 120)">
            <circle cx="0" cy="0" r="22" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="14" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="6" class="glyph-ring-core" />
          </g>

          <!-- Nodo 2 -->
          <g class="circuit-node-glyph" transform="translate(220, 280)">
            <circle cx="0" cy="0" r="20" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="13" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="5" class="glyph-ring-core" />
          </g>

          <!-- Nodo 3 (Centro superior) -->
          <g class="circuit-node-glyph" transform="translate(520, 320)">
            <circle cx="0" cy="0" r="24" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="15" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="7" class="glyph-ring-core pulse-fast" />
          </g>

          <!-- Nodo 4 -->
          <g class="circuit-node-glyph" transform="translate(760, 480)">
            <circle cx="0" cy="0" r="22" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="14" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="6" class="glyph-ring-core" />
          </g>

          <!-- Nodo 5 -->
          <g class="circuit-node-glyph" transform="translate(980, 660)">
            <circle cx="0" cy="0" r="20" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="13" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="5" class="glyph-ring-core" />
          </g>

          <!-- Nodo 6 -->
          <g class="circuit-node-glyph" transform="translate(380, 420)">
            <circle cx="0" cy="0" r="22" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="14" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="6" class="glyph-ring-core" />
          </g>

          <!-- Nodo 7 -->
          <g class="circuit-node-glyph" transform="translate(900, 160)">
            <circle cx="0" cy="0" r="20" class="glyph-ring-outer" />
            <circle cx="0" cy="0" r="13" class="glyph-ring-dark" />
            <circle cx="0" cy="0" r="5" class="glyph-ring-core" />
          </g>
        </g>

        <!-- Paquetes de Luz / Datos que se desplazan por las líneas -->
        <g class="data-packets">
          <circle r="4" class="data-packet">
            <animateMotion 
              dur="7s" 
              repeatCount="indefinite" 
              path="M 80,120 L 220,120 L 220,280 L 480,280 L 520,320 L 520,480 L 760,480 L 820,540 L 1120,540" 
            />
          </circle>
          <circle r="3.5" class="data-packet packet-delay">
            <animateMotion 
              dur="9s" 
              repeatCount="indefinite" 
              path="M 120,620 L 320,620 L 380,560 L 380,420 L 520,320 L 680,220 L 900,160 L 1100,160" 
            />
          </circle>
          <circle r="4" class="data-packet packet-alt">
            <animateMotion 
              dur="8s" 
              repeatCount="indefinite" 
              path="M 980,660 L 760,660 L 760,480 L 520,320 L 480,280 L 220,280 L 220,120 L 80,120" 
            />
          </circle>
        </g>
      </svg>
    </div>

    <div class="conocenos__content">
      <div class="conocenos__badge animate-on-scroll">
        <span class="dot"></span> +14 AÑOS DE TRAYECTORIA EN TECNOLOGÍA
      </div>

      <h2 class="conocenos__title animate-on-scroll">
        SOLUCIONES INTEGRALES EN<br> 
        <span class="title-gradient">TECNOLOGÍA, ELECTRÓNICA Y REDES</span>
      </h2>

      <div class="conocenos__description-box animate-on-scroll">
        <p class="conocenos__description">
          Cubrimos todas las ramas tecnológicas con laboratorio especializado, infraestructura y soporte corporativo garantizado.
        </p>
        <div class="highlight-badge">
          <span class="pulse-icon">⚡</span>
          ¡Revisión y diagnóstico GRATIS! <span class="highlight-text-small">Tiempo estimado: 24 a 72 horas.</span>
        </div>
      </div>

      <!-- SECCIÓN PRINCIPAL: 10 ÁREAS GENERALES CON EFECTO CIRCUITO DE LA IMAGEN -->
      <div class="circuit-services-container animate-on-scroll">
        <div class="circuit-services-grid">
          <router-link
            v-for="(area, index) in areasGenerales"
            :key="area.id"
            :to="area.ruta"
            class="circuit-node-item animate-on-scroll"
            :data-delay="(index * 0.04).toFixed(2)"
            :title="`Ver servicios de ${area.nombre}`"
          >
            <!-- Nodo Concéntrico (idéntico al diseño de la imagen) -->
            <div class="node-bullet-wrapper" aria-hidden="true">
              <span class="node-ring-outer"></span>
              <span class="node-ring-inner"></span>
              <span class="node-ring-core"></span>
              <span class="node-stem-line"></span>
            </div>

            <!-- Contenido de la Tarjeta del Servicio -->
            <div class="node-label-box">
              <span class="node-icon">{{ area.icono }}</span>
              <div class="node-text-wrapper">
                <span class="node-title">{{ area.nombre }}</span>
                <span class="node-sublabel">{{ area.descripcion }}</span>
              </div>
              <i class="fas fa-chevron-right node-arrow"></i>
            </div>
          </router-link>
        </div>
      </div>

      <!-- BOTONES DE ACCIÓN INFERIORES -->
      <div class="conocenos__actions animate-on-scroll">
        <router-link to="/contactanos" class="btn-primary">
          <i class="fas fa-calendar-check"></i>
          Agenda tu diagnóstico gratis
        </router-link>
        <router-link to="/catalogo" class="btn-secondary">
          <i class="fas fa-store"></i>
          Visitar tienda
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';

// Las 10 Áreas Generales solicitadas (reemplazando los 20 micro-servicios saturados)
const areasGenerales = [
  {
    id: 'redes',
    nombre: 'Redes y Telecomunicaciones',
    descripcion: 'Cableado estructurado, fibra, routers y switches',
    icono: '🌐',
    ruta: '/servicio/redes'
  },
  {
    id: 'camaras',
    nombre: 'Cámaras de Seguridad CCTV',
    descripcion: 'Instalación y monitoreo HD / IP',
    icono: '📹',
    ruta: '/servicio/camaras'
  },
  {
    id: 'moviles',
    nombre: 'Dispositivos Móviles',
    descripcion: 'Pantallas, baterías, microsoldadura y placas',
    icono: '📱',
    ruta: '/servicio/moviles'
  },
  {
    id: 'computacion',
    nombre: 'Computación y Laptops',
    descripcion: 'Mantenimiento, hardware, Mac y Windows',
    icono: '💻',
    ruta: '/servicio/computacion'
  },
  {
    id: 'alarmas',
    nombre: 'Sistemas de Alarmas',
    descripcion: 'Sensores de intrusión, cercos y control',
    icono: '🚨',
    ruta: '/servicio/alarmas'
  },
  {
    id: 'juegos',
    nombre: 'Juegos y Consolas',
    descripcion: 'PlayStation, Xbox, Nintendo y mandos',
    icono: '🎮',
    ruta: '/servicio/juegos'
  },
  {
    id: 'electronica',
    nombre: 'Electrónica General',
    descripcion: 'Reparación de circuitos, fuentes y placas',
    icono: '⚡',
    ruta: '/servicio/electronica'
  },
  {
    id: 'impresora',
    nombre: 'Impresoras y Escáneres',
    descripcion: 'Mantenimiento de cabezales, tóner y tinta',
    icono: '🖨️',
    ruta: '/servicio/impresora'
  },
  {
    id: 'inter',
    nombre: 'Inter y Conectividad',
    descripcion: 'Soporte de enlaces, fibra óptica y datos',
    icono: '📡',
    ruta: '/servicio/empresas'
  },
  {
    id: 'sistemas',
    nombre: 'Sistemas Administrativos',
    descripcion: 'Ventas, inventario, facturación y cajas',
    icono: '📊',
    ruta: '/servicio/empresas'
  }
];

let observer = null;
let failsafeTimer = null;

onMounted(() => {
  // Animación suave de entrada con GSAP
  setTimeout(() => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    if (typeof gsap !== 'undefined' && elements.length) {
      document.documentElement.classList.add('gsap-ready');

      failsafeTimer = setTimeout(() => {
        elements.forEach((el) => el.classList.add('visible'));
      }, 500);

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;

            gsap.fromTo(
              el,
              { opacity: 0, y: 22, scale: 0.96 },
              {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 0.55,
                ease: 'back.out(1.2)',
                delay: el.dataset.delay || 0,
                onComplete: () => {
                  el.classList.add('visible');
                  gsap.set(el, { clearProps: 'opacity,transform' });
                }
              }
            );
            observer.unobserve(el);
          });
        },
        { threshold: 0.05 }
      );

      elements.forEach((el, i) => {
        el.dataset.delay = Math.min(i * 0.04, 0.4).toFixed(2);
        observer.observe(el);
      });
    }
  }, 60);
});

onBeforeUnmount(() => {
  if (observer) observer.disconnect();
  if (failsafeTimer) clearTimeout(failsafeTimer);
});
</script>

<style src="@/css/Conocenos/conocenos.css"></style>
